import { FC, useContext, useState } from "react";
import NotificationDispatch, { showErrorNotification } from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useAdminCostsApi } from "../../http/costs/api";
import ModalDialog from "../ui/ModalDialog";

type DeleteCostDialogProps = {
  costId: string;
  carId: string;
  onClose: () => void;
};

const DeleteCostDialog: FC<DeleteCostDialogProps> = ({ costId, carId, onClose }) => {
  const i18n = useI18n();
  const costsApi = useAdminCostsApi();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <ModalDialog
      onClose={onClose}
      title={i18n.t.costs.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: onClose,
        },
        {
          title: i18n.t.common.yes,

          onClick: () => {
            setIsSubmitting(true);
            costsApi
              .deleteAdminCost(costId, carId)
              .then(onClose)
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.costs.questions.delete}
    </ModalDialog>
  );
};
export default DeleteCostDialog;
